import { combineReducers } from "redux";

import auth from "./auth";
import supplier from "./supplier";
import apparatus from "./apparatus";
import user from "./user";
import scriptLibrary from "./scriptLibrary";
import sample from "./sample";
import sampleList from "./sampleList";
import email from "./email";
import scoreConfig from "./scoreConfig";
import shopList from "./shopList";
import order from "./order";
import scoreDeploy from "./scoreDeploy";
import raidsys from "./raidsys";
import mine from "./mine";
import checklist from "./checklist";
import userGroup from "./userGroup";
import groupDetail from "./groupDetail";

export default combineReducers({
  auth,
  supplier,
  apparatus,
  user,
  scriptLibrary,
  sample,
  sampleList,
  email,
  scoreConfig,
  shopList,
  order,
  scoreDeploy,
  raidsys,
  mine,
  checklist,
  userGroup,
  groupDetail,
});
